import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css"; // Bootstrap CSS import karein

const NotFound = () => {
  const navigate = useNavigate();
  const [lang, setLang] = useState("en");

  // Custom styling jo Bootstrap classes se cover nahi hoti
  const styles = {
    container: {
      background: "linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)", // Soft gradient background
    },
    errorCode: {
      fontSize: "150px",
      fontWeight: "900",
      background: "linear-gradient(45deg, #31ADDC, #3DB752)", // Bootstrap Primary to Purple
      WebkitBackgroundClip: "text",
      WebkitTextFillColor: "transparent",
      lineHeight: "1",
      textShadow: "0px 10px 20px rgba(0,0,0,0.1)",
    },
    glassCard: {
      background: "rgba(255, 255, 255, 0.8)",
      backdropFilter: "blur(10px)",
      border: "1px solid rgba(255, 255, 255, 0.3)",
      borderRadius: "20px",
      boxShadow: "0 8px 32px 0 rgba(31, 38, 135, 0.15)",
    },
  };

  return (
    <div
      className="d-flex align-items-center justify-content-center min-vh-100"
      style={styles.container}
    >
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-md-8 col-lg-6 text-center">
            {/* Card Content */}
            <div className="p-5" style={styles.glassCard}>
              {/* 404 Big Text */}
              <h1 className="mb-0" style={styles.errorCode}>
                404
              </h1>

              {/* Heading */}
              <h2 className="mb-3 fw-bold text-dark">Page Not Found</h2>

              {/* Language toggle */}

              {/* Description - two variants */}
              <p className="text-secondary mb-4 fs-5">
                The page you are looking for could not be found. Please contact
                us if you need assistance.
              </p>
              {/* Buttons */}
              <div className="d-flex justify-content-center gap-3">
                <button
                  onClick={() => navigate("/")}
                  className="btn btn-dark rounded-pill px-4 py-2 fw-semibold shadow-sm"
                >
                  Back to Home
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
